import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      meta: {
        title: '首頁',
        menuCss: 'active-home'
      },
      component: () => import('./views/template/Layout'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('./views/Home')
        }
      ]
    },
    {
      path: '/live',
      meta: {
        title: '直播列表',
        menuCss: 'active-live'
      },
      redirect: { name: 'LiveList' },
      component: () => import('./views/template/Layout'),
      children: [
        {
          path: 'list',
          name: 'LiveList',
          component: () => import('./views/live/LiveList')
        },
        {
          path: 'watch/:lid',
          name: 'LiveWatch',
          component: () => import('./views/live/LiveWatch')
        }
      ]
    },
    {
      path: '/video',
      meta: {
        title: '影音隨選',
        menuCss: 'active-video'
      },
      redirect: { name: 'NotFoundPage' },
      component: () => import('./views/template/Layout'),
      children: [
        {
          path: 'list/:cid/:scid?',
          name: 'VideoList',
          component: () => import('./views/video/VideoList')
        },
        {
          path: 'watch/:vid',
          name: 'VideoWatch',
          component: () => import('./views/video/VideoWatch')
        },
        {
          path: 'search',
          name: 'VideoSearch',
          component: () => import('./views/video/VideoSearch')
        }
      ]
    },
    {
      path: '/watch',
      meta: {
        title: '影片播放',
        menuCss: 'active-video'
      },
      component: () => import('./views/template/Layout'),
      children: [
        {
          path: ':vid',
          name: 'Watch',
          component: () => import('./views/Home')
        }
      ]
    },
    {
      path: '*',
      meta: {
        title: '找不到頁面',
        requireAuth: true
      },
      component: () => import('./views/template/Layout'),
      children: [
        {
          path: '',
          name: 'NotFoundPage',
          component: () => import('./views/error/404')
        }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (store.state.token) {
    try {
      await store.dispatch('getUserInfo', store.state.token)
    } catch (err) {
      // alert('帳號已登出！')
      // console.log(err.data)
    }
  }
  next()
  // if (to.name && to.name.indexOf('Login') === 0 && !store.state.auth) {
  //   if (store.state.token) { // 未登入，但是 Storge 有 Token 存在，用 Token 獲取帳號資訊
  //     try {
  //       await store.dispatch('getUserInfo', { token: store.state.token, checkId: store.state.checkId })
  //       if (store.state.auth) {
  //         next({ name: 'Home' })
  //       }
  //     } catch (err) {
  //     }
  //   }
  // }
  //
  // if (to.matched.some(record => record.meta.requireAuth) || to.name === null) {
  //   if (!store.state.auth) { // 檢查是否登入
  //     if (store.state.token) { // 未登入，但是 Storge 有 Token 存在，用 Token 獲取帳號資訊
  //       try {
  //         await store.dispatch('getUserInfo', { token: store.state.token, checkId: store.state.checkId })
  //         if (store.state.auth) {
  //           next(to)
  //         } else {
  //           window.alert('請重新登入系統')
  //           store.commit('clearToken')
  //           next({ name: 'Login' })
  //         }
  //       } catch (err) {
  //         window.alert('請重新登入系統')
  //         store.commit('clearToken')
  //         next({ name: 'Login' })
  //       }
  //     } else {
  //       window.alert('請重新登入系統')
  //       store.commit('clearToken')
  //       next({ name: 'Login' })
  //     }
  //   } else {
  //     next()
  //   }
  // } else {
  //   if (to.name && to.name.indexOf('Login') === 0 && store.state.auth) {
  //     next({ name: 'Home' })
  //   } else {
  //     next()
  //   }
  // }
})

export default router
